import { chatMessagesData } from "./advancedForm";
import { application } from "./application";
import { candidatelist } from "./candidateList";
import { cartData } from "./cart";
import { jobcategories } from "./category";
//import { lineAreaChart, lineBarChart, pieChart, donutChart, polarChart, radarChart } from "./chartjs";
import { groupData, chatData, MessagesData, contactData } from "./chat";
import { companieslist } from "./companiesList";
import { Contacts, Companies, deals, Leads } from "./crm";
import { Market, cryptoICOList, cryptoOrders, Transactions, BitcoinChart, litecoinChart, EatherreumChart, BinanceChart, DashChart, TetherChart, NeoChart, Wallets } from "./crypto"
import { Customers } from "./customer";
import { analyticstatData, analyticTopPages, BestSelling, TopSelling, Recentelling, statData, cryptostatData, cryptoBitcoinChart, cryptolitecoinChart, cryptoEatherreumChart, cryptoBinanceChart, cryptoDashChart, cryptoTetherChart, cryptoNeoChart, cryptoCurrencies, cryptoTopPerformers, cryptoNewsFeed } from "./dashboard";
import { nftstatData, nftfeaturedData, nftrecentData, nfttopCollectionData, nftpopularData } from "./dashboardnft";
import { projectstatData, ActiveProjects, MyTask, TeamMembers } from "./dashboardProject";
import { Recommendedjob, jobcandidate } from "./dashboardJob";
import { category, calendarEvents } from "./calendar";
import { emailData } from "./email";
import { IconsData } from "./featherIcon";
import { folderData, recentData } from "./file-manager";
import { invoiceData } from "./invoice";
import { joblist, jobgrid } from "./jobList";
import { tasks } from "./kanban";
import { icons } from "./materialIcon";
import { Orders } from "./order";
import { MonthlyPlan, YearlyPlan, pricingPlan, SimplePlan } from "./pricing";
import { Products } from "./product";
import { projectListWidgets } from "./project";
import { projectDocument, ProjectTeam } from "./project_overview";
import { projectList, document } from "./projectList";
import { nftwalletData, collectionData, creatorsData, creatorsListData, exploreData, marketplaceData, tradingData, recentMarketData, popularData, rankingData } from "./nft";
import { remixicons } from "./remixIcon";
import { swiper, gallery, news, video } from "./search";
import { BitcoinsellerChart, MicroChart, NestaChart, iTestChart, MetaChart, DigitechChart, SyntyceChart, ZoeticChart, sellerDetals } from "./seller";
import { sellerDetail } from "./sellerDetail";
import { COUNTRIES, AssignedData } from "./taskList";
import { Team } from "./team";
import { ticketList } from "./ticketList";
import { todoList, todoAssigned, todoProject } from "./todoList";
import { tileBoxs1, tileBoxs2, tileBoxs3, tileBoxs4, otherWidgets, widgetsActivities, widgetsTasks, tileBoxs5, hotproducts, candidate, bank } from "./widget";
import { apikeys } from "./apikey";
import { ListJs, paginationlist, dataattribute, existingList, FuzzyList, GridJs } from "./tablelistjs";
import { crmstatData, DealsStatus, UpcomingActivities, ClosingDeals } from "./dashboardCrm";

export {
    chatMessagesData,
    application,
    candidatelist,
    cartData,
    jobcategories,
    //lineAreaChart, lineBarChart, pieChart, donutChart, polarChart, radarChart,
    groupData, chatData, MessagesData, contactData,
    collectionData,
    companieslist,
    creatorsData, creatorsListData,
    Contacts, Companies, deals, Leads,
    Market,
    cryptoICOList,
    cryptoOrders,
    Transactions,
    BitcoinChart, litecoinChart, EatherreumChart, BinanceChart, DashChart, TetherChart, NeoChart, Wallets,
    Customers,
    analyticstatData, analyticTopPages, BestSelling, TopSelling, Recentelling, statData, cryptostatData, cryptoBitcoinChart, cryptolitecoinChart, cryptoEatherreumChart, cryptoBinanceChart, cryptoDashChart, cryptoTetherChart, cryptoNeoChart, cryptoCurrencies, cryptoTopPerformers, cryptoNewsFeed,
    nftstatData, nftfeaturedData, nftrecentData, nfttopCollectionData, nftpopularData,
    projectstatData, ActiveProjects, MyTask, TeamMembers,
    emailData,
    exploreData,
    IconsData,
    folderData, recentData,
    invoiceData,
    joblist, jobgrid,
    tasks,
    marketplaceData, tradingData, recentMarketData, popularData,
    icons,
    nftwalletData,
    Orders,
    MonthlyPlan, YearlyPlan, pricingPlan, SimplePlan,
    Products,
    projectListWidgets,
    projectDocument, ProjectTeam,
    projectList, document,
    rankingData,
    remixicons,
    swiper, gallery, news, video,
    BitcoinsellerChart, MicroChart, NestaChart, iTestChart, MetaChart, DigitechChart, SyntyceChart, ZoeticChart, sellerDetals,
    sellerDetail,
    COUNTRIES, AssignedData,
    Team,
    ticketList,
    todoList, todoAssigned, todoProject,
    tileBoxs1, tileBoxs2, tileBoxs3, tileBoxs4, otherWidgets, widgetsActivities, widgetsTasks, tileBoxs5, hotproducts, candidate, bank,
    apikeys,
    ListJs, paginationlist, dataattribute, existingList, FuzzyList, GridJs,
    Recommendedjob, jobcandidate,
    category, calendarEvents,
    crmstatData, DealsStatus, UpcomingActivities, ClosingDeals
}